import { render, staticRenderFns } from "./VAdministrationAddCommentModal.vue?vue&type=template&id=1dc54a44&"
import script from "./VAdministrationAddCommentModal.vue?vue&type=script&lang=ts&"
export * from "./VAdministrationAddCommentModal.vue?vue&type=script&lang=ts&"
import style0 from "./VAdministrationAddCommentModal.vue?vue&type=style&index=0&id=1dc54a44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports